export default {
  state: {
    patient: {},
    patInfo: {},
    preSettle: {},
    showTip: false,
  },
  mutations: {
    savePatient(state, payload) {
      state.patient = payload
    },
    savePatInfo(state, payload) {
      state.patInfo = payload
    },
    savePreSettle(state, payload) {
      state.preSettle = payload
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/settle.js